module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_8_Doran.6175cd1d6a3dbc946c09ae27d7db12e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_8_Doran.png
// module id = 755
// module chunks = 0